import {User} from 'Services';

/**
 * @method handleMessagePreview
 * @param {string} message
 * @return {string}
 */
const handleMessagePreview = (message) => {
    if (message.length <= 40) {
        return message;
    }

    return message.slice(0, 40) + ' ...';
}

/**
 * @method isSameChat
 * @param {object} user_a
 * @param {object} user_b
 * @return {boolean}
 */
const isSameChat = (user_a, user_b) => {
    return (user_a.type === user_b.type && user_a.id === user_b.id);
}

/**
 * @method isSameChatCheck
 * @return {object}
 */
const isSameChatCheck = () => {
    return (o, object) => { return isSameChat(o, object) };
}

/**
 * @method isSameChat
 * @param {object} user
 * @return {boolean}
 */
const isThisUser = (user) => {
    return (user.type === 'App\\Models\\User' && user.id === User.id);
}

export {
    handleMessagePreview,
    isSameChat,
    isSameChatCheck,
    isThisUser,
}
